import * as Types from 'echarts/types/dist/echarts';

import { getThemeColor } from '~/design-tokens/themes/theme-utils';
import { ThemeName } from '~/design-tokens/themes/themes';

import { SingleSeries } from '../apache-config';

const lineStyles: Types.LineSeriesOption = {
  type: 'line',
  seriesLayoutBy: 'row',
  emphasis: { focus: 'series' },
};

const pieStyles: Types.SeriesOption = {
  type: 'pie',
  radius: ['20%', '80%'],
  avoidLabelOverlap: true,
  tooltip: {
    show: false,
  },
  label: {
    formatter: '{b}: {d}%',
  },
};
export interface AxisPointerEvent {
  axesInfo: Array<{
    axisDim: 'x' | 'y';
    axisIndex: number;
    value: number;
  }>;
}

interface GenerateDoughnutSeriesProps {
  series: SingleSeries[];
  dataIndex: number;
  isShowLineChart: boolean;
  chartWidth?: number;
  theme?: ThemeName;
}

export const generateDoughnutSeries = ({
  series,
  dataIndex,
  isShowLineChart,
  chartWidth,
  theme = 'dark_default',
}: GenerateDoughnutSeriesProps): Types.SeriesOption[] => {
  const formattedSeries = series.map(item => ({
    value: item.data[dataIndex] === null ? undefined : item.data[dataIndex],
    name: item.name,
  }));

  const isAllNegative = formattedSeries.every(
    item => item.value !== undefined && item.value < 0
  );

  const shouldApplyLabelStyles = chartWidth !== undefined && chartWidth <= 740;

  const dynamicPieStyles: Types.SeriesOption = {
    ...pieStyles,
    label: {
      ...pieStyles.label,
      ...(shouldApplyLabelStyles && {
        position: 'inner',
        overflow: 'truncate',
        width: chartWidth / 2,
        textStyle: {
          color: getThemeColor('--text-default', theme),
        },
      }),
    },
  };

  if (isShowLineChart) {
    const linesSeries = series.map(item => ({
      ...lineStyles,
      ...item,
    }));
    return [
      ...linesSeries,
      {
        ...dynamicPieStyles,
        radius: '30%',
        center: ['50%', '25%'],
        data: isAllNegative
          ? formattedSeries.map(item => ({
              ...item,
              value:
                item.value !== undefined ? Math.abs(item.value) : item.value,
            }))
          : formattedSeries,
      },
    ];
  }

  return [
    {
      ...dynamicPieStyles,
      data: formattedSeries,
    },
  ];
};
